import * as s from "./SideNavBarStyled";
import { useAppSelector } from "redux/hooks";

import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import * as mediaQuery from "components/MediaQuery";
import UserProfile from "../headernav/sub/UserProfile";
import { useMenu } from "hook/useMenu";

type SideBarProps = {
  isCollapsed: boolean;
  onOpen?: () => void;
};

export const MYDW_LOGO =
  "https://mydw-front.s3.us-west-1.amazonaws.com/image/myDW.svg";

function TopInfo({ isCollapsed, onOpen }: SideBarProps): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { returnToStartPage } = useMenu({});
  return (
    <s.ProfileContainer>
      {/* logo */}
      <s.Logo
        alt="logo"
        src={
          selectedAccount.companyLogo !== "" &&
          selectedAccount.companyLogo !== undefined
            ? selectedAccount.companyLogo
            : MYDW_LOGO
        }
        isCollapsed={isCollapsed}
        onClick={() => {
          if (
            !selectedAccount.isEnabled &&
            selectedAccount.accountLevel === LEVEL_TYPE.EU
          ) {
            return;
          }
          returnToStartPage({
            startPage: selectedAccount.accountLevel === LEVEL_TYPE.DW ? 3 : 1,
          });
          onOpen && onOpen();
        }}
        data-testid="blocks-sidenav-sidenav-logo-return-to-start-page"
      />

      <mediaQuery.Mobile>
        <UserProfile onConfirmScreenRecording={() => {}} />

        <s.UserInfo>
          <s.SidebarLevel level={selectedAccount.accountLevel}>
            {/* 직급 ex. DW, CP */}
            {selectedAccount.accountLevel}
          </s.SidebarLevel>
        </s.UserInfo>
      </mediaQuery.Mobile>
    </s.ProfileContainer>
  );
}

export default TopInfo;
